import { call, put } from "redux-saga/effects";
import { setCars, setCar, setActiveRequests, setUnActiveRequests, setSingleRequest, setPartOffers } from "../../entities/userCars";
import { createUserCar, requestGetActiveRequests, requestGetCar, requestGetCars, requestGetPartOffers, requestGetSingleRequest, requestGetUnActiveRequests } from "../requests/userCars";

export function* handleGetCars(_action) {
    try {
        const response = yield call(requestGetCars);
        const { data } = response;
        yield put(setCars({ ...data }));
    } catch (error) {
        console.log(error);
    }
}


export function* handleGetCar(action) {
    try {
        const response = yield call(requestGetCar, action.payload);
        const { data } = response;
        yield put(setCar({ ...data }));
    } catch (error) {
        console.log(error);
    }
}



export function* handleGetActiveRequests(action) {
    try {
        const response = yield call(requestGetActiveRequests, action.payload);
        const { data } = response;
        yield put(setActiveRequests({ ...data }));
    } catch (error) {
        console.log(error);
    }
}


export function* handleGetUnActiveRequests(action) {
    try {
        const response = yield call(requestGetUnActiveRequests, action.payload);
        const { data } = response;
        yield put(setUnActiveRequests({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleGetSingleRequest(action) {
    try {
        const response = yield call(requestGetSingleRequest, action.payload);
        const { data } = response;
        yield put(setSingleRequest({ ...data }));
    } catch (error) {
        console.log(error);
    }
}


export function* handleGetPartOffers(action) {
    try {
        const response = yield call(requestGetPartOffers, action.payload);
        const { data } = response;
        yield put(setPartOffers({ ...data }));
    } catch (error) {
        console.log(error);
    }
}

export function* handleCreateUserCar(action) {
    try {
        yield call(createUserCar, action.payload);
    } catch (error) {
        console.log(error);
    }
}